module.exports = __webpack_public_path__ + "img/red-pita-08.cc7a4b0e.png";